<template>
  <div class="actualite-area gray-bg section-padding pt-100">
    <div class="container">
      <!-- LOADING -->
      <div v-if="loading" class="loading-container">
        <div class="spinner"></div>
        <p>Chargement des vidéos…</p>
      </div>

      <div v-else class="row actualite-item-wrap">
        <!-- Boucle sur les articles -->
        <div class="col-3 mb-5" v-for="item in articles" :key="item.id">
          
          <!-- Titre de l’article -->
          <!-- <h3 class="article-title text-center mb-4">{{ item.titre }}</h3> -->

          <!-- Grille des médias -->
          <div class="row justify-content-center g-3">
            
            <!-- Si YouTube -->
            <div 
              v-if="item.source && isYoutubeUrl(item.source)"
              
            >
              <div class="media-box">
                <iframe
                  :src="getYoutubeEmbedUrl(item.source)"
                  class="media-frame"
                  allowfullscreen
                ></iframe>
              </div>
            </div>

            <!--  Boucle sur les médias -->
            <!-- <div
              v-for="(media, index) in item.medias"
              :key="media.id"
              class="col-lg-3 col-md-4 col-sm-6"
            >
              <div class="media-box">
                <template v-if="isVideo(media.description)">
                  <video controls class="media-frame">
                    <source :src="getImageUrl(media.description)" type="video/mp4" />
                  </video>
                </template>
              </div>
            </div> -->
            <!-- ✅ Titre en bas de la vidéo -->
            <div class="video-title">
              {{ item.titre }}
            </div>
          </div>
        </div>
      </div>
      <div class="mb-4">
          <PaginationComponent :page="page" :totalPages="totalPages" :totalElements="totalElements" :limit="limit" @paginate="handlePaginate" />
      </div>
    </div>
  </div>
</template>

 
<script lang="ts">
 
import ApiService from "@/services/ApiService";
import { getUrlApiForFiles, error,format_Date } from "@/utils/utils";
import { defineComponent, ref, onMounted, computed } from "vue";
import { Article } from "@/models/Article";
import PaginationComponent from '@/components/Utilities/Pagination.vue';

export default defineComponent({
    name: 'ActualitePoste',
    components: {
      PaginationComponent,

  },
  setup(){

interface Articles {
  id: number;
  titre: string;
  sousTitre: string;
  source?: string;
  urlImage?: string;
  contenu: string;
  datePublication: Date;
  nbrupload: number;
  categorieArticle?: {
    id: number;
    nom: string;
  };
  medias?: Media[];
}

interface Media {
  id: number;
  type: string;
  description: string;
  articleId: number;
}
 
interface CategorieArticle {
  id: number
  nom: string
}
 
const articles = ref<Array<Articles>>([]);   

        // BEGIN PAGINATE
    const searchTerm = ref('');
    const page = ref(1);
    const totalPages = ref(0);
    const limit = ref(10);
    const totalElements = ref(0);
    const loading = ref(false);


    const handlePaginate = ({ page_, limit_ }) => {
      try {
        page.value = page_;
        getTreeArticle(page_, limit_);
      } catch (error) {
        //
      }
    };

function isVideo(filename: string): boolean {
  return /\.(mp4|webm|ogg)$/i.test(filename);
}
function isYoutubeUrl(url: string): boolean {
  return /youtube\.com\/watch\?v=|youtu\.be\//.test(url);
}

function getYoutubeEmbedUrl(url: string): string {
  let videoId = '';
  const match = url.match(/(?:v=|youtu\.be\/)([^&]+)/);
  if (match) videoId = match[1];
  
  return `https://www.youtube.com/embed/${videoId}`;
}


 
 
//Chargement des articles liés à un menu
   function getTreeArticle(page = 1, limi = 8, searchTerm = '') {
  loading.value = true;
  const start = Date.now();

  return ApiService.get(`/actualite/articles/44?page=${page}&limit=${limi}&mot=${searchTerm}&`)
    .then(({ data }) => {
      articles.value = data.data.data;
      totalPages.value = data.data.totalPages;
      limit.value = data.data.limit;
      totalElements.value = data.data.totalElements;
    })
    .catch(({ response }) => {
      error(response.data.message);
    })
    .finally(() => {
      const elapsed = Date.now() - start;
      const delay = Math.max(300 - elapsed, 0);
      setTimeout(() => loading.value = false, delay);
    });
}


 
    onMounted(() => {
        getTreeArticle();
    });
 
 
    return { 
            articles,
            getUrlApiForFiles,
            format_Date,
            page, 
            totalPages,
            limit,
            totalElements,
            handlePaginate,
            getYoutubeEmbedUrl,
            isVideo,
            isYoutubeUrl,
            loading
        };
  },
});

</script>
 
<style scoped>
.article-title {
  font-size: 1.6rem;
  font-weight: 600;
  color: #222;
  text-transform: uppercase;
  border-bottom: 2px solid #007bff;
  display: inline-block;
  padding-bottom: 8px;
  margin-bottom: 25px;
}

.media-box {
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 4px 15px rgba(0,0,0,0.1);
  overflow: hidden;
  transition: transform 0.3s ease;
}
.media-box:hover {
  transform: scale(1.03);
}

.media-frame {
  width: 100%;
  height: 200px;
  object-fit: cover;
  border: none;
  display: block;
}

.pdf-box {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 200px;
  background: #f8f9fa;
  color: #007bff;
  font-weight: 600;
  text-decoration: none;
  border: 2px dashed #007bff;
  border-radius: 10px;
}

.pdf-box:hover {
  background: #007bff;
  color: white;
}

/* Espacements entre articles */
.actualite-item-wrap {
  margin-top: 50px;
}

@media (max-width: 768px) {
  .media-frame {
    height: 180px;
  }
}
.loading-container {
  min-height: 300px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 15px;
}

.spinner {
  width: 50px;
  height: 50px;
  border: 5px solid #e0e0e0;
  border-top: 5px solid #007bff;
  border-radius: 50%;
  animation: spin 0.9s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.video-title {
  padding: 12px;
  font-size: 16px;
  font-weight: 600;
  text-align: center;
  background: #f8f9fa;
  color: #222;
  border-top: 1px solid #eee;
}


</style>